(() => {
  function bind(root = document) {
    root.querySelectorAll('[data-ax-present]').forEach(section => {
      if (section.dataset.bound) return;
      section.dataset.bound = 'true';
      const track = section.querySelector('[data-ax-track]');
      const viewer = section.querySelector('[data-ax-viewer]');
      const stage = section.querySelector('[data-ax-stage]');
      section.querySelectorAll('[data-ax-scroll]').forEach(button => button.addEventListener('click', () => {
        track.scrollBy({ left: track.clientWidth * Number(button.dataset.axScroll), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }));
      section.querySelectorAll('[data-ax-open]').forEach(button => button.addEventListener('click', () => {
        const template = [...section.querySelectorAll('[data-ax-template]')].find(item => item.dataset.axTemplate === button.dataset.axOpen);
        if (!template) return;
        stage.replaceChildren(template.content.cloneNode(true));
        viewer.showModal();
        const video = stage.querySelector('video');
        if (video) video.play().catch(() => {});
      }));
      viewer.querySelector('[data-ax-close]').addEventListener('click', () => viewer.close());
      viewer.addEventListener('close', () => {
        stage.querySelectorAll('video').forEach(video => video.pause());
        stage.replaceChildren();
      });
      viewer.addEventListener('click', event => {
        const rect = viewer.getBoundingClientRect();
        if (event.target === viewer && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) viewer.close();
      });
    });
  }
  bind();
  document.addEventListener('shopify:section:load', event => bind(event.target));
})();
